import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldTree } from '@angular/forms/signals';

@Component({
  selector: 'app-unsupported-field',
  standalone: true,
  imports: [],
  templateUrl: './unsupported-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Keeps a caller's static `id` attribute off the host element, which would
  // otherwise duplicate the `id` the template below puts on the message text.
  host: { '[attr.id]': 'null' },
})
export class UnsupportedFieldComponent {
  readonly field = input.required<FieldTree<unknown>>();
  readonly id = input('');
  readonly label = input('Unsupported field');
  readonly containerClass = input('');
  readonly message = input(
    'This field is not supported by the current version.'
  );
}
